import { useEffect } from 'react';
import uuid from 'uuid-random';
import { debounce } from 'underscore';
import { useDispatch } from 'react-redux';

import { setResizeData } from '@interlayer/js/components/system/App/store/buzz/actions';

export const useSetResizeData = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const debouncedUpdateResizeData = debounce(() => {
            dispatch(setResizeData({
                id: uuid(),
                width: window.innerWidth,
                height: window.innerHeight
            }));
        }, 300);

        window.addEventListener('resize', debouncedUpdateResizeData);

        return () => window.removeEventListener('resize', debouncedUpdateResizeData);
    }, [dispatch]);
};
